module.exports = "/build/images/favicon.f9c172e7.ico";